import $ from 'jquery';
import debounce from 'lodash/debounce';
import Flickity from 'flickity';
import { breakpoints } from "../utils";

export default class {
  constructor(el) {
    const self = this;
    self.$el = $(el);
    self.state = null;
    self.$links = self.$el.find(".js-timeline__link");
    self.$eventsContainer = self.$el.find(".js-timeline__events");
    self.$events = self.$el.find(".js-timeline__event");
    self.resize = debounce(self.resize.bind(self), 250);

    $(window).on('resize', self.resize).trigger('resize');

    self.$links.on('click', event => {
      var $link = $(event.currentTarget).parent();
      var index = $link.index();
      self.$events.removeClass('is-active');
      self.$events.eq(index).addClass('is-active');
      $link.parent().children().removeClass('is-active is-passed');
      $link.prevAll().addClass('is-passed');
      $link.addClass('is-active');
      $.proxy(self.scroll, self)();
      event.preventDefault();
    }).first().click();

    $(window).on('scroll', function(){
      $.proxy(self.scroll, self)();
    }).trigger('scroll');
  }
  scroll() {
    var self = this;
    if(self.state === "desktop"){
      var sT = $(window).scrollTop();
      var $activeEvent = self.$events.filter(".is-active");
      if(self.$eventsContainer.offset().top <= sT + $(".c-header").height() + 18) {
        if($(".c-header").height() + $activeEvent.outerHeight(true) + sT >= self.$el.offset().top + self.$el.height()) {
          $activeEvent.addClass('is-fixed-bottom').removeClass('is-fixed');
        } else {
          $activeEvent.addClass('is-fixed').removeClass('is-fixed-bottom');
        }
      } else {
        $activeEvent.removeClass('is-fixed-bottom is-fixed');
      }
    }
  }
  resize() {
    const self = this;

    if($(window).width() < breakpoints.tablet) {
      let maxHeight = 0;
      self.$events.css("height", "auto");
      self.$events.each((index, el) => {
        maxHeight = Math.max(maxHeight, $(el).outerHeight());
      });
      // self.$events.css("height", `${maxHeight}px`);
      if(self.flkty){
        self.flkty.resize();
      }
    } else {
      self.$events.css("height", "auto");
    }

    if($(window).width() < breakpoints.tablet && self.state !== "mobile") {
      self.flkty = new Flickity(self.$eventsContainer.get(0), {
        prevNextButtons: true,
        contain: true,
        arrowShape: "M76.2147793,95.9144081 C77.1580205,96.8483102 77.1580205,98.3656644 76.2147793,99.2995665 C75.2715381,100.233469 73.7390103,100.233469 72.7958255,99.2996223 L24.7064719,51.7015955 C24.2527668,51.2523825 24,50.6444177 24,50.0071174 C24,49.3733265 24.2540195,48.7654189 24.706486,48.3126254 L72.7939607,0.705074639 C73.250971,0.247924392 73.865482,0 74.5033563,0 C75.1382467,0 75.7518241,0.245773772 76.2147793,0.699477105 C77.1580205,1.63337918 77.1580205,3.1507334 76.2147793,4.08463548 L29.8331274,50.0070599 L76.2147793,95.9144081 Z",
        setGallerySize: true,
        pageDots: false,
        adaptiveHeight: true,
      });
      self.state = "mobile";
    } else if($(window).width() >= breakpoints.tablet && self.state !== "desktop") {
      if(self.flkty){
        self.flkty.destroy();
      }
      self.state = "desktop";
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/components/Timeline.js